// Expo constants
import Constants from "expo-constants"

// Default configs
export default {
	apiurl: Constants.manifest.extra.apiurl || `http://${Constants?.manifest?.debuggerHost?.split(':')?.shift() || window?.location?.hostname}` || 'http://localhost:9000',
	weburl: Constants.manifest.extra.weburl || window?.location?.origin || `http://${Constants?.manifest?.debuggerHost?.split(':')?.shift()}:19006` || 'http://localhost'
}
